import { Box, styled, Typography } from "@mui/material";
import React from "react";
import PlansChartTable from "./PlansChartTable";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_best_pr": {
    fontWeight: 700,
    fontSize: "2rem",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

function PlansChart() {
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Typography variant="h1" className="lpl_best_pr">
        Compare all plans
      </Typography>
      <Typography
        variant="body1"
        fontWeight={300}
        maxWidth={400}
        letterSpacing={"0.2px"}
      >
        Choose the plan that’s right for your business. Whether you’re just
        getting started with email marketing.
      </Typography>

      {/* table */}

      <PlansChartTable />
    </MainView>
  );
}

export default PlansChart;
